if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        document.addEventListener('change', (event) => {
  if (event.target.matches('input[data-color-value]')) {
    this.filterMediaByColor(event.target.dataset.colorValue);
  }
});

const initialColor = document.querySelector(
  'input[data-color-value]:checked'
)?.dataset.colorValue;

if (initialColor) {
  this.filterMediaByColor(initialColor);
}

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            if (this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
  
  filterMediaByColor(selectedColor) {
  const normalizeColor = (value) =>
    (value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const selected = normalizeColor(selectedColor);

  const slides = this.elements.viewer?.querySelectorAll('[id^="Slide-"]') || [];

  // ===== GALERÍA PRINCIPAL =====
  slides.forEach((slide, index) => {
    const mediaColor = normalizeColor(slide.dataset.mediaColor);

    // El primer slide es la imagen destacada de la variante seleccionada.
    // Siempre debe permanecer visible.
    const isFeaturedSlide = index === 0;

    const visible =
      !selected ||
      isFeaturedSlide ||
      mediaColor.includes(selected);

    slide.hidden = !visible;

    // Evita que un slide oculto siga ocupando espacio en el slider móvil.
    if (visible) {
      slide.style.removeProperty('display');
    } else {
      slide.style.display = 'none';
    }
  });

  // ===== MINIATURAS: MÁXIMO 5 =====
if (this.elements.thumbnails) {
  const thumbnails = Array.from(
    this.elements.thumbnails.querySelectorAll('[data-target]')
  );

  let visibleCount = 0;

  thumbnails.forEach((thumbnail) => {
    const targetId = thumbnail.dataset.target;

    const slide = this.elements.viewer?.querySelector(
      `[data-media-id="${targetId}"]`
    );

    if (!slide || slide.hidden) {
      thumbnail.hidden = true;
      thumbnail.style.display = 'none';
      return;
    }

    if (visibleCount < 5) {
      thumbnail.hidden = false;
      thumbnail.style.removeProperty('display');
      visibleCount++;
    } else {
      thumbnail.hidden = true;
      thumbnail.style.display = 'none';
    }
  });
}

  // ===== RECALCULAR SLIDER PRINCIPAL =====
  if (this.elements.viewer?.resetPages) {
    this.elements.viewer.resetPages();
  }

  // ===== RECALCULAR MINIATURAS =====
  if (this.elements.thumbnails?.resetPages) {
    this.elements.thumbnails.resetPages();
  }

  // ===== VOLVER A LA PRIMERA IMAGEN VISIBLE =====
  const firstVisibleSlide = Array.from(slides).find(
    (slide) => !slide.hidden
  );

  if (firstVisibleSlide) {
    this.setActiveMedia(firstVisibleSlide.dataset.mediaId, false);
  }
}

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

